import * as React from 'react';

import {
  NativeSelect,
  NativeSelectOptGroup,
  NativeSelectOption,
} from './components/ui/native-select.js';
import { TOUCH_LAYOUT_CLASSES } from './lib/touch-layout-classes.js';
import { cn } from './lib/utils.js';

type DimeSelectProps = Readonly<
  Omit<React.ComponentProps<typeof NativeSelect>, 'size'> & {
    /** `touch` is a 44px target for a picker's tablet or phone. */
    size?: 'sm' | 'default' | 'touch';
    /** Sits inside the control beside the chevron, such as a completion check. */
    trailing?: React.ReactNode;
  }
>;

export function DimeSelect({ size = 'default', className, trailing, ...props }: DimeSelectProps) {
  const touch = size === 'touch';
  const select = (
    <NativeSelect
      {...props}
      size={touch ? 'default' : size}
      className={cn(
        touch && TOUCH_LAYOUT_CLASSES.nativeSelect,
        trailing !== undefined && 'w-full',
        trailing ? '[&>select]:pr-14' : undefined,
        className,
      )}
    />
  );
  if (trailing === undefined) return select;
  return (
    <div className="relative w-fit">
      {select}
      <span className="absolute inset-y-0 right-8 flex items-center">{trailing}</span>
    </div>
  );
}

export const DimeSelectOption = NativeSelectOption;
export const DimeSelectOptGroup = NativeSelectOptGroup;
